import {negativeListService} from "../services";

export default (file) => {
    return new Promise(async (resolve) => {
        const formData = new FormData();
        formData.append('file', file);

        await negativeListService.uploadNegativeList(formData)
            .then(response => {
                resolve(response.data)
            })
    })
}
